import { sendData, sendForBlobData } from './apiService';
import NotificationManager from 'react-notifications/lib/NotificationManager';

export async function getAllForFinance(query, value) {
  try {
    let response = await sendData(
      `custom-duty-invoice/get-custom-duty-invoice-for-purchase?total=true&${new URLSearchParams(query).toString()}`,
      value,
      'POST',
      false
    );
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function exportFinanceData(data) {
  return await sendForBlobData('custom-duty-invoice/get-custom-duty-invoice-for-finance-export', data, {
    responseType: 'blob',
  });
}
